import { CrossBlackIcon } from "@/src/Asset";
import FilterListSection from "./components/FilterListSection";
import SelectedOptionsSection from "./components/SelectedOptionsSection";
import SelectedFilterPopup from "./components/SelectedFilterPopup";
import { useEffect } from "react";

const ListingPageMobileFilterComponent = ({
  filterOptions,
  selectedFilterCategory,
  setSelectedFilterCategory,
  filterData,
  collegesUrl,
  location,
  availableStreams,
  filterSecStreamData,
  handleModalToggle,
}: any) => {
  // For stop background scroll when popup is open:
  useEffect(() => {
    // Save original styles
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    // Lock scroll
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      // Restore scroll when modal unmounts
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  return (
    <div className="fixed inset-0 bottom-0 flex items-end justify-center md:items-end bg-black/40  ">
    
      <div className="w-full h-[85%]  bg-white rounded-t-2xl transition-transform duration-300 ease-in-out transform translate-y-0 ">
        {/* header and button */}
        <div className="flex justify-between border-b-2 p-4">
          <div className="">
            <h3 className="text-[#334988] text-xl font-bold">Filters</h3>
          </div>
          <div className="flex items-center gap-2">
            {/* cancel button: */}
            <button
              onClick={() => {
                setSelectedFilterCategory("");
                handleModalToggle();
              }}
              className="text-gray-600 hover:text-gray-900 text-2xl bg-gray-100/50 border p-1 border-gray-300 rounded-full"
            >
              <CrossBlackIcon className="scale-75" />
            </button>
          </div>
        </div>

        {/* Main Filter UI */}
        <div className="flex h-full overflow-y-auto bg-white">
        <div className="flex h-full overflow-y-auto bg-white">
          {/* Left Panel */}
          <div className="w-1/4 border-r-2 pr-2 overflow-y-auto pt-2 px-1 mb-20">
            {/* list of types of filters */}
            <FilterListSection
              filterOptions={filterOptions}
              setSelectedFilterCategory={setSelectedFilterCategory}
            />
          </div>

          {/* Right Panel: to list the sections for filter */}
          <div className="w-3/4 overflow-y-auto m-4 bg-white mb-20">
            <SelectedFilterPopup
              filterData={filterData}
              selectedFilterCategory={selectedFilterCategory}
              setSelectedFilterCategory={setSelectedFilterCategory}
              filterOptions={filterOptions}
              collegesUrl={collegesUrl}
              location={location}
              filterSecStreamData={filterSecStreamData}
              availableStreams={availableStreams}
              handleModalToggle={handleModalToggle}
            />
          </div>
        </div>
        {/* here print selected list in a straight line */}
        <div className="sticky bottom-0 w-full px-4 py-2 h-auto border-t-2 flex gap-4 text-sm overflow-auto hide-scrollbar bg-white">
          <SelectedOptionsSection
            filterOptions={filterOptions}
            collegesUrl={collegesUrl}
            location={location}
            setSelectedFilterCategory={setSelectedFilterCategory}
          />
        </div>
      </div>
    </div>

    </div>
  );
};


export default ListingPageMobileFilterComponent;
